//This is the subcategorie filter on the side bar we added on the fly
//If the subcat matches the state of the filter it will only return the manual files in that subcat

export function SubCatFilter(data, subCat) {
  if (subCat == "") {
    return data;
  }
  if (data.field_planters_subcategories.length > 0) {
    return (
      data.field_planters_subcategories == subCat ||
      data.field_planters_subcategories[0] == subCat ||
      data.field_planters_subcategories[1] == subCat
    );
  } else if (data.field_no_till_drill_subcategorie.length > 0) {
    return (
      data.field_no_till_drill_subcategorie == subCat ||
      data.field_no_till_drill_subcategorie[0] == subCat ||
      data.field_no_till_drill_subcategorie[1] == subCat
    );
  } else if (data.field_min_till_drill_subcategory.length > 0) {
    return (
      data.field_min_till_drill_subcategory == subCat ||
      data.field_min_till_drill_subcategory[0] == subCat ||
      data.field_min_till_drill_subcategory[1] == subCat
    );
  } else if (data.field_precision_seeding_subcateg.length > 0) {
    return (
      data.field_precision_seeding_subcateg == subCat ||
      data.field_precision_seeding_subcateg[0] == subCat ||
      data.field_precision_seeding_subcateg[1] == subCat
    );
  } else if (data.field_sprayer_subcategories.length > 0) {
    return (
      data.field_sprayer_subcategories == subCat ||
      data.field_sprayer_subcategories[0] == subCat ||
      data.field_sprayer_subcategories[1] == subCat
    );
  } else if (data.field_tillage_attachment_subcate.length > 0) {
    return (
      data.field_tillage_attachment_subcate == subCat ||
      data.field_tillage_attachment_subcate[0] == subCat ||
      data.field_tillage_attachment_subcate[1] == subCat
    );
  } else if (data.field_tillage_subcategories.length > 0) {
    return (
      data.field_tillage_subcategories == subCat ||
      data.field_tillage_subcategories[0] == subCat ||
      data.field_tillage_subcategories[1] == subCat
    );
  } else {
    return data;
  }
}
